export const initialState = {
    cityStationsList: null,
    rjDataList: null,
    activeCityStations:null
  };